import cn from 'classnames';
import styles from './icon.module.sass';
import * as Icons from '@intigral/icons';

export const fontIcons = [
    'arrow',
    'arrow-down',
    'basket',
    'bell',
    'bell-circle',
    'bell-disabled',
    'bell-filled',
    'bell-filled-circle',
    'check-circle',
    // TODO: rename to `check`?
    'check-green',
    'close',
    'compass',
    'coupon',
    'cross',
    'cross-circle',
    'down-small',
    'edit',
    'envelope',
    'eye',
    'eye-off',
    'globe',
    'heart',
    'heart-filled',
    'home',
    'info',
    'left-arrow',
    'lock',
    'lock-filled',
    'monitor',
    'mute',
    'news',
    'phone',
    'play',
    'play-outline',
    'right-arrow',
    'search',
    'shop',
    'smile',
    'submenu-vertical',
    'submenu-horizontal',
    'submenu-horizontal-circle',
    'tv-shows',
    'full-screen',
    'menu',
    'menu-bars',
    'exclamation-mark',
    'edit',
    'off',
    'settings',
    'volume-1',
    'play-tv',
    'cart',
    'games',
    'sort-list',
    'sort-block',
    'like',
    'dislike',
    'like-filled',
    'dislike-filled',
    'live',
    'episodes',
    'play-back',
    'text',
    'user',
    'download',
    'cry',
    'exit',
    'settings',
    'pencil',
    'switcher',
    'mobile',
    'wifi',
    'exclamation',
    'download-offline',
    'rewind',
    'minus',
    'filters',
    'calendar',
    'live-tv',
    'live-text',
    'reward',
    'arrow-left-thick',
    'sar',
    'add',
    'more',
] as const;

export type FontIconName = (typeof fontIcons)[number];

export type FontIconColor = 'gray' | 'green' | 'orange' | 'red' | '';
export type FontIconSize = 'x-small' | 'smaller' | 'small' | 'medium' | 'large' | 'size60' | 'x-large';

interface FontIconProps {
    name: FontIconName;
    color?: FontIconColor;
    size?: FontIconSize;
    md?: FontIconSize;
    rotate?: 'left' | 'right' | 'flip' | 'partial' | null;
    className?: string;
}

export const FontIcon = ({
    name,
    color = '',
    size = 'smaller',
    md = 'small',
    rotate = null,
    className,
}: FontIconProps) => {
    const isUsingReactComponents = true;

    if (isUsingReactComponents) {
        const pascalCaseName = toPascalCase(name);
        const Icon = Icons[pascalCaseName];

        if (!Icon) return null;

        return <Icon size={size} md={md} color={color} rotate={rotate} className={className} />;
    }

    return (
        <span
            className={cn(
                styles.icon,
                styles[color],
                styles[size],
                styles['md-' + md],
                styles['name-' + name],
                rotate && styles['rotate-' + rotate],
                className
            )}
        ></span>
    );
};

// https://en.wiktionary.org/wiki/Pascal_case
function toPascalCase(string: string) {
    return `${string}`
        .toLowerCase()
        .replace(new RegExp(/[-_]+/, 'g'), ' ')
        .replace(new RegExp(/[^\w\s]/, 'g'), '')
        .replace(new RegExp(/\s+(.)(\w*)/, 'g'), ($1, $2, $3) => `${$2.toUpperCase() + $3}`)
        .replace(new RegExp(/\w/), (s) => s.toUpperCase());
}
